import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
} from "@mui/material";
import { useAppSelector } from "../../hooks";
import { useDispatch } from "react-redux";
import { closeBlockSettings } from "../../store/game/gameSlice";
import { BlockTypes } from "../../models/block-types";
import { LoadBalancerSettings } from "./LoadBalancerSettings";

export const BlockSettingsModal: React.FC = () => {
  const dispatch = useDispatch();
  const openBlockId = useAppSelector(
    (state) => state.game.settingsModalOpenForBlockId,
  );
  const block = useAppSelector((state) =>
    openBlockId ? state.game.blocks[openBlockId] : null,
  );
  const edges = useAppSelector((state) => state.game.edges);
  const allBlocks = useAppSelector((state) => state.game.blocks);
  const trafficRoutes = useAppSelector((state) => state.game.trafficRoutes);

  const onClose = () => dispatch(closeBlockSettings());

  if (!openBlockId || !block) {
    return (
      <Dialog open={!!openBlockId} onClose={onClose} maxWidth="sm" fullWidth>
        <DialogTitle>Settings</DialogTitle>
        <DialogContent dividers>Block not found or unsupported.</DialogContent>
        <DialogActions>
          <Button onClick={onClose} variant="contained">
            Close
          </Button>
        </DialogActions>
      </Dialog>
    );
  }

  const connectedBlockIds = edges
    .filter((e) => e.source === block.id)
    .map((e) => e.target);
  const connectedBlocks = connectedBlockIds.map((id) => allBlocks[id]);

  return (
    <Dialog open={!!openBlockId} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{block.customName || "Block"} Settings</DialogTitle>
      <DialogContent dividers>
        {block.blockType === BlockTypes.LOAD_BALANCER ? (
          <LoadBalancerSettings
            block={block}
            connectedBlocks={connectedBlocks}
            trafficRoutes={trafficRoutes}
          />
        ) : (
          <div>No specific settings available for this block type.</div>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} variant="contained">
          Done
        </Button>
      </DialogActions>
    </Dialog>
  );
};
